// extracted by css-extract-rspack-plugin
export default {"Cell":"cmTaqX31mxMjJ5g6","IsNumbered":"nVt9SEvR8Owr6em3","slim":"etugaNK96QKJjVk_"};